import { createContext, useContext } from 'react';

import { useFormContext } from 'react-hook-form';

type MultiStepFormContextType = {
  previewMode?: boolean;
};

export const MultiStepFormContext = createContext<MultiStepFormContextType>({
  previewMode: false
});

export const useMultiStepFormContext = () => {
  const { previewMode } = useContext(MultiStepFormContext);
  const formContext = useFormContext();

  return { ...formContext, previewMode };
};
